import React from "react";
import { ExternalLink } from "lucide-react";

export default function GoodsListItem({ goods }) {
  return (
    <a
      href={goods.purchase_link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden group p-4"
    >
      {/* 상품 이미지 */}
      <div className="relative w-32 h-32 shrink-0 bg-gray-100 dark:bg-gray-700 overflow-hidden rounded-md">
        <img
          src={goods.image_url}
          alt={goods.prod_name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
          loading="lazy"
        />
      </div>

      {/* 상품 정보 */}
      <div className="flex-1 ml-4 flex flex-col justify-between">
        <div>
          <h3 className="text-base font-medium text-gray-900 dark:text-gray-100 line-clamp-2 mb-2">
            {goods.prod_name}
          </h3>
          {goods.maker_name && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">
              제조사: {goods.maker_name}
            </p>
          )}
        </div>

        <div className="flex items-center justify-between mt-2">
          <span className="text-lg font-bold text-gray-900 dark:text-gray-100">
            {typeof goods.display_total_price === "number"
              ? `₩${goods.display_total_price.toLocaleString()}`
              : goods.display_total_price}
          </span>
          <ExternalLink
            className="w-5 h-5 text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-300"
            aria-hidden="true"
          />
        </div>
      </div>
    </a>
  );
}
